import actions from 'react/api/actions';
import { fromJS } from 'immutable';

const initialState = fromJS({
  policies: [],
});

export default (state = initialState, action) => {

  if (actions.passwordPolicies.actions.fetchPoliciesSuccess === action.type){
    const { policies } = action;
    return state.mergeIn(['policies'], policies);
  }

  return state;
};
